import { NavDropdown } from './NavDropdown';
import { normalizeNavPath } from './navPath';
import { useUseCaseNavLinks } from '../../context/UseCaseNavContext';

type UseCasesNavDropdownProps = {
  pathname: string;
};

function isUseCasesActive(pathname: string) {
  const path = normalizeNavPath(pathname);
  return path.startsWith('/use-cases/');
}

export function isUseCasesNavActive(pathname: string) {
  return isUseCasesActive(pathname);
}

export function UseCasesNavDropdown({ pathname }: UseCasesNavDropdownProps) {
  const { links } = useUseCaseNavLinks();

  if (links.length === 0) {
    return null;
  }

  return (
    <NavDropdown
      label="Use Cases"
      links={links}
      pathname={pathname}
      isActive={isUseCasesActive}
    />
  );
}
